export default "__VITE_ASSET__a7e82fa8__"